const AllUserTypesList = `
query
{
  allUserTypesList
  {
    userTypeId
    typeName
    createBy
    createDate
    updateBy
    updateDate
  }
}`;

module.exports = {
  ALL_USER_TYPES_QUERY: AllUserTypesList,
};
